/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useGetCurrentModel } from "hooks/useGetCurrentModel";
import { useUpdateComponent } from "../hooks/use-update-component";


const ComponentErrorFallback = (props) => {

    const error = props?.error;
    const resetErrorBoundary = props?.resetErrorBoundary;
    const resetErrorMsg = props?.resetErrorMsg;
    const { t } = useTranslation();
    const model = useGetCurrentModel();
    const { component } = useUpdateComponent();

    const { type } = component || {};
    const { guid, type: model_type } = model || {};

    const resetToEmpty = async () => {
        // const { type } = field || {}
        // const empty = getDefaultImpl(type)
        // empty.settings.hide = false
        // applyFieldChanges(field, empty)
        location.reload();
    };

    return (
        <div role='alert'
            style={{
                // backgroundColor: '#f5b5b5', color: '#222222',
                backgroundColor: "#f4ebeb", color: "#222222",
                borderRadius: "8px", border: "1px solid #ff1c1c",
                padding: "20px",
                fontSize: "11px", fontFamily: "Roboto, Helvetica, Arial",
                width: "1024px",
                height: "500px",
                marginBottom: "16px"
            }}
        >
            <h2>{t("commons.somethingWentWrong")}</h2>
            <h3 style={{ color: "#990000" }}>{model_type} - {guid}</h3>
            <h3 style={{ color: "#990000" }}>{type}</h3>
            <pre style={{ color: "#990000" }}>{error?.message}</pre>
            <div style={{
                // border: '1px solid red',
                width: "984px", height: "280px",
                overflow: "scroll",
                marginBottom: "16px"
            }}
            >
                <pre>{error?.stack}</pre>
            </div>
            <div style={{ display: "flex", flexDirection: "row", gap: "12px", justifyContent: "flex-end" }}>
                <Button
                    variant='contained'
                    onClick={resetErrorBoundary}
                >
                    {resetErrorMsg ? resetErrorMsg : "Try again"}
                </Button>

                <Button
                    variant='contained'
                    onClick={resetToEmpty}
                >
                    Reset to Empty
                </Button>
            </div>
        </div>
    );
};

export { ComponentErrorFallback };
